import React from 'react';

import { ModalButtonTrigger } from '@atlassian/entry-points/modal-button-trigger';
import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';

import { modalEntryPoint } from '../fixtures/modal-entry-point';
import { RelayWrapper } from '../utils/wrapper';

function Application(): React.JSX.Element {
	return (
		<ModalButtonTrigger
			entryPoint={modalEntryPoint}
			modalTitle="Example Modal"
			loadingText="Loading example modal"
		>
			Open modal
		</ModalButtonTrigger>
	);
}

export default function ModalContextProviderExample(): React.JSX.Element {
	return (
		<RelayWrapper>
			<ModalContextProvider>
				<Application />
			</ModalContextProvider>
		</RelayWrapper>
	);
}
